var _defs, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09,17.5v-.65A1,1,0,0,1,4.5,16a10.86,10.86,0,0,1,5.59-1.54h.07a7.23,7.23,0,0,1,.6-2l-.67,0a12.82,12.82,0,0,0-6.61,1.82,2.92,2.92,0,0,0-1.39,2.53V19.5h9.26a7.13,7.13,0,0,1-1-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.09,11.5a4,4,0,1,0-4-4A4,4,0,0,0,10.09,11.5Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,10.09,5.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.84,15.5c0-.22,0-.42-.06-.63l1.13-1-1-1.73-1.45.49A3.52,3.52,0,0,0,18.38,12l-.29-1.49h-2L15.78,12a3.78,3.78,0,0,0-1.08.63l-1.44-.49-1,1.73,1.14,1a3.34,3.34,0,0,0,0,1.26l-1.14,1,1,1.73,1.44-.49a3.78,3.78,0,0,0,1.08.63l.31,1.49h2L18.38,19a3.52,3.52,0,0,0,1.08-.63l1.45.49,1-1.73-1.13-1C20.8,15.92,20.84,15.72,20.84,15.5Zm-3.75,2a2,2,0,1,1,2-2A2,2,0,0,1,17.09,17.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSetting);
export default __webpack_public_path__ + "static/media/user-setting.bf3f2d48.svg";
export { ForwardRef as ReactComponent };